import "@hotwired/stimulus";
import "@hotwired/turbo";
import "flowbite-datepicker";
import "flowbite/dist/flowbite.turbo.js";
import Papa from "papaparse";
import "./controllers";

window.Papa = Papa;

// Register service worker for PWA and keep it up to date.
//
// Without proactive update checks, mobile PWA users can run a stale SW
// indefinitely (Android/iOS throttle the 24-hour background check).
// A stale SW missing the push handler silently drops push notifications.
if (navigator.serviceWorker) {
  navigator.serviceWorker
    .register("/service-worker", { scope: "/" })
    .then((registration) => {
      // Check once when the app starts.
      registration.update().catch((error) => {
        console.warn("Service worker update check failed:", error);
      });

      // Check periodically for long-lived PWA sessions.
      setInterval(() => {
        registration.update().catch((error) => {
          console.warn("Service worker update check failed:", error);
        });
      }, 60 * 60 * 1000);

      // Self-heal orphaned push subscriptions: if the browser has a subscription
      // but the server-side record was deleted (e.g. 410 cleanup), re-POST it.
      syncPushSubscription(registration);
    })
    .catch((error) => {
      console.warn("Service worker registration failed:", error);
    });
}

function syncPushSubscription(registration) {
  const url = document.querySelector('meta[name="push-subscriptions-url"]')?.content;
  const vapidKey = document.querySelector('meta[name="vapid-public-key"]')?.content;
  if (!url) return;

  registration.pushManager.getSubscription().then(async (subscription) => {
    if (!subscription) return;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({
        sync: true,
        push_subscription: {
          endpoint: subscription.toJSON().endpoint,
          p256dh_key: subscription.toJSON().keys?.p256dh,
          auth_key: subscription.toJSON().keys?.auth
        }
      })
    });

    const data = await response.json().catch(() => null);
    if (data?.resubscribe && vapidKey) {
      await subscription.unsubscribe().catch(() => {});
      const newSub = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey)
      });
      const newJson = newSub.toJSON();
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          sync: true,
          push_subscription: {
            endpoint: newJson.endpoint,
            p256dh_key: newJson.keys?.p256dh,
            auth_key: newJson.keys?.auth
          }
        })
      });
    }
  }).catch(() => {});
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
